import { isEqual } from 'lodash';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';

import {
  BLUEBIRD_SETTINGS_FIRESTORE_COLLECTION,
  DEFAULT_EXPERIENCE_BLUEPRINT_FIRESTORE_DOC_ID,
} from '../../constants/shell';
import { updateDefaultExperienceBlueprint } from '../../store/actions/shell';
import { syncBlueprintToTemplateDraft } from '../../store/actions/templates';
import { IClaimLinkTemplate } from '../../types/templates';

const DefaultExperienceBlueprint = () => {
  const firebase = useFirebase();
  const dispatch = useDispatch();
  const lastBlueprintRef = useRef<Partial<IClaimLinkTemplate> | null>(null);

  useEffect(() => {
    return firebase
      .firestore()
      .collection(BLUEBIRD_SETTINGS_FIRESTORE_COLLECTION)
      .doc(DEFAULT_EXPERIENCE_BLUEPRINT_FIRESTORE_DOC_ID)
      .onSnapshot(
        (snapshot) => {
          const data = snapshot?.data();
          if (!data) {
            return;
          }
          const blueprint = data as Partial<IClaimLinkTemplate>;
          dispatch(updateDefaultExperienceBlueprint(blueprint));
          // Sync into an open builder draft only when the blueprint actually changes
          // mid-session. onSnapshot always fires on page load, and that initial snapshot
          // must not overwrite draft defaults that come from a saved template.
          if (lastBlueprintRef.current && !isEqual(lastBlueprintRef.current, blueprint)) {
            dispatch(syncBlueprintToTemplateDraft(blueprint));
          }
          lastBlueprintRef.current = blueprint;
        },
        (error) => {
          console.error('DefaultExperienceBlueprint listener error:', error);
        },
      );
  }, [firebase, dispatch]);

  return null;
};

export default DefaultExperienceBlueprint;
